import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  
  connect() {
    // console.log("FreetextSearchController connected")
    // document.addEventListener('body:refresh', this.refresh);
    this.active = false
  }

  disconnect() {
    // document.removeEventListener('body:refresh', this.refresh);
  }

  show(event) {
    this.active = true
    this.element.classList.add("active")
    this.inputTarget.focus()
  }

  close(event) {
    this.active = false
    this.element.classList.remove("active")
  }

  handleInput(event) {
    // console.log("freetext search handle input", event.key)
    if (event.key === 'Enter' || event.key === 'Escape') {
      this.active = false
      this.element.classList.toggle("active", this.active)
    }
  }
 }
